export default "__VITE_ASSET__BFCAwHcr__"